import materials from "./materials";
import vendors from "./vendors";

export const manufacturing = {
    materials,
    vendors,
};

export default manufacturing;
